function capitalizeString(string:string){
    /*Capitalizing the title in JavaScript...*/
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export default capitalizeString;